(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mso', {
            parent: 'entity',
            url: '/mso',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.mso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/mso/msos.html',
                    controller: 'MsoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mso-detail', {
            parent: 'mso',
            url: '/mso/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.mso.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/mso/mso-detail.html',
                    controller: 'MsoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Mso', function($stateParams, Mso) {
                    return Mso.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mso',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mso-detail.edit', {
            parent: 'mso-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'MsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mso.new', {
            parent: 'mso',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'MsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                msoName: null,
                                msoAddress: null,
                                msoNoMotcode: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('mso', null, { reload: 'mso' });
                }, function() {
                    $state.go('mso');
                });
            }]
        })
        .state('mso.edit', {
            parent: 'mso',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'MsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mso', null, { reload: 'mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mso.delete', {
            parent: 'mso',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-delete-dialog.html',
                    controller: 'MsoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mso', null, { reload: 'mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
